import React from "react";
import PropTypes from "prop-types";

import { Warning as WarningIcon } from "@material-ui/icons";
import { Chip, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  selectable: {
    cursor: "pointer",
  },
}));

const ChipCell = ({ value, chipValue, warning }) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      width="180px"
    >
      {chipValue && (
        <Chip
          className={classes.selectable}
          size="small"
          icon={warning ? <WarningIcon /> : undefined}
          color={warning ? "secondary" : "primary"}
          label={chipValue}
        />
      )}
      <Box marginTop={1} className={classes.selectable}>
        {value}
      </Box>
    </Box>
  );
};

ChipCell.propTypes = {
  value: PropTypes.node.isRequired,
  chipValue: PropTypes.node.isRequired,
  warning: PropTypes.bool,
};

ChipCell.defaultProps = {
  warning: false,
};

export default ChipCell;
